<template>
    <b-container flex>
        <b-row style="margin-bottom: 10px ">
            <b-col cols="8">Total Grid Electricity (kWh)*</b-col>
            <b-col cols="2">
                <b-form-input readonly v-model=totalGridElectricity min="0" max="1000000" step=".10"
                              type="number"></b-form-input>
            </b-col>
        </b-row>
        <b-row align-h="start" style="padding-bottom: 10px">
          <b-col cols="1"></b-col>
          <b-col cols="10" style="color: darkgreen; font-style: italic">*If you have solar, grid use is electricity
            purchased beyond what is produced by solar.
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 10px ">
            <b-col cols="8">Total Solar PV Electricity (kWh)</b-col>
            <b-col cols="2">
                <b-form-input readonly v-model="totalSolarElectricity" min="0" max="1000000" step=".10"
                              type="number"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12"></b-col>
        </b-row>
        <b-row style="margin-bottom: 10px ">
            <b-col cols="8">Total Electricity (kWh)</b-col>
            <b-col cols="2">
                <b-form-input readonly v-model="totalElectricity" min="0" max="1000000" step=".10"
                              type="number"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12"></b-col>
        </b-row>
        <b-row style="margin-bottom: 10px ">
            <b-col cols="8">Water Use for Process + Office + Hospitality (gallons)*</b-col>
            <b-col cols="2">
                <b-form-input readonly v-model="totalOfficeWater" min="0" max="1000000" step=".10"
                              type="number"></b-form-input>
            </b-col>
        </b-row>
        <b-row align-h="start" style="padding-bottom: 10px">
          <b-col cols="1"></b-col>
          <b-col cols="10" style="color: darkgreen; font-style: italic">*Note if only one meter also tracks landscape
            water use
          </b-col>
        </b-row>
      <b-row style="margin-bottom: 10px ">
        <b-col cols="8">Landscape water used</b-col>
        <b-col cols="2">
          <b-form-input readonly v-model="landscapeWater" min="0" max="1000000" step=".10"
                        type="number"/>
        </b-col>
      </b-row>
      <b-row style="margin-bottom: 10px ">
        <b-col cols="8">Total Water Used</b-col>
        <b-col cols="2">
          <b-form-input readonly v-model="totalWaterUsed" min="0" max="1000000" step=".10"
                        type="number"/>
        </b-col>
      </b-row>
      <b-row align-h="center" style="margin-bottom: 15px">
        <b-col cols="8">
        </b-col>
      </b-row>


    </b-container>
</template>

<script>
import Bus from "../eventBus";


export default {
  name: "MetricsSummaryBlock",
  props: {year: String},
  data() {
    return {
      totalGridElectricity: 0,
      totalSolarElectricity: 0,
      totalElectricity: 0,
      totalOfficeWater: 0,
      landscapeWater: 0,
      tastingOffices: 0,
      wineryProcess: 0,
      totalGridElectricity1: 0,
      totalGridElectricity2: 0,
      totalGridElectricity3: 0,
      myYear: Number(this.year)
    }
  },
  created() {
    Bus.$on('grid-edited', this.updateTotals);
  },
  beforeDestroy() {
    Bus.$off('grid-edited', this.updateTotals);
  },
  computed: {
    totalWaterUsed: function () {
      return Number(this.wineryProcess) + Number(this.landscapeWater) + Number(this.tastingOffices);
    }
  },
  methods: {
    updateTotals: function (total) {
      console.log("Updating Metrics Summary for: ", total)
      if (Number(total.year) === this.myYear) {
        if (total.gridType === "solarProductivity") {
          this.totalSolarElectricity = total.total;

        } else if (total.gridType === "electricMeter") {
          this.totalGridElectricity1 = total.total;
          this.totalGridElectricity = this.totalGridElectricity1 + this.totalGridElectricity2 + this.totalGridElectricity3;
        } else if (total.gridType === "electricMeter2") {
          this.totalGridElectricity2 = total.total;
          this.totalGridElectricity = this.totalGridElectricity1 + this.totalGridElectricity2 + this.totalGridElectricity3;

        } else if (total.gridType === "electricMeter3") {
          this.totalGridElectricity3 = total.total;
          this.totalGridElectricity = this.totalGridElectricity1 + this.totalGridElectricity2 + this.totalGridElectricity3;
        } else if (total.gridType === "waterGrid") {
          this.landscapeWater = total.landscaping;
          this.wineryProcess = total.wineryProcess;
          this.tastingOffices = total.tastingOffices;
          this.totalOfficeWater = (this.wineryProcess + this.tastingOffices).toFixed(1);
        } else if (total.gridType === "powerEmission") {
          this.totalGridElectricity = total.totalGrid;
          this.totalSolarElectricity = total.totalSolar;
          this.totalElectricity = (this.totalGridElectricity + this.totalSolarElectricity).toFixed(1);
        }
                }
            }
        }
    }
</script>

<style scoped>

</style>
